import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_DASHBOARD } from '../routes/paths';
// config
import { docsOrigin } from '../config';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node
};

// `returnTo` (set by the CMS's /docs middleware) is always an absolute URL. Only
// follow it if it points at an origin we actually expect, to avoid an open redirect.
function getValidReturnTo(returnTo) {
  if (!returnTo) return null;
  try {
    const url = new URL(returnTo);
    const allowedOrigins = [window.location.origin, docsOrigin].filter(Boolean);
    return allowedOrigins.includes(url.origin) ? returnTo : null;
  } catch {
    return null;
  }
}

export default function GuestGuard({ children }) {
  const { isAuthenticated } = useAuth();
  const { pathname, search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const type = searchParams.get('type');
  const returnTo = getValidReturnTo(searchParams.get('returnTo'));

  useEffect(() => {
    if (isAuthenticated && returnTo) {
      // Full browser navigation, not client-side routing: `returnTo` (e.g. /docs/...)
      // isn't an SPA route, and may be on a different origin entirely (local dev).
      window.location.assign(returnTo);
    }
  }, [isAuthenticated, returnTo]);

  if (isAuthenticated) {
    // if (pathname.includes("auth/register") && type) {
    //   return <>{children}</>;
    // }
    if (returnTo) {
      return null;
    }
    return <Navigate to={PATH_DASHBOARD.root} />;
  }

  return <>{children}</>;
}
